import React from 'react'
import './WinnerStatusComponent.css'
const WinnerStatusComponent = () => {
  return (
    <div className="banner_section" style={{ flex: 1 }}>
      WinnerStatusComponent
    </div>
  )
}

export default WinnerStatusComponent